<template>
  <div class="d-flex flex-column">
    <div v-if="state.banners.length > 0" class="overflow-auto hidden-scrollbar header-content">
      <div class="d-flex flex-row">
        <template v-for="banner in state.banners" :key="banner.name">
          <welcome v-if="banner.name ==='welcome'" :config="banner.config"></welcome>
        </template>
      </div>
    </div>

    <div class="header">
      <span class="text-capitalize-first">{{$t('latest_wins')}}</span>
    </div>
    <loader-content :ref="(el: any) => liveWinsLoader = el">
    <div class="overflow-auto hidden-scrollbar header-content">
      <TransitionGroup name="animation-list" tag="div" class="d-flex flex-row position-relative">
        <LiveWin v-for="(item, index) in store.getters.liveWins" :item="item" :key="`${item.createdAt}_${item.gameId}_${item.userId}`"></LiveWin>
      </TransitionGroup>
    </div>
    </loader-content>

    <div class="header">
      <svg-icon icon="menu/tournaments"></svg-icon>
      <span class="text-capitalize-first">{{$t('tournaments')}}</span>
    </div>
    <loader-content :ref="(el: any) => liveTournamentsLoader = el">
    <div class="overflow-auto hidden-scrollbar header-content">
      <div class="d-flex flex-row">
        <TournamentCard v-for="(item, index) in store.getters.liveTournaments" :item="item" :key="item.id" class="slide"></TournamentCard>
      </div>
    </div>
    </loader-content>

    <div :class="[store.getters.favoriteGames.length === 0 ? 'd-none': '']" >
      <div class="header">
        <svg-icon icon="my_favs"></svg-icon>
        <span class="text-capitalize-first">{{$t('favorite_games')}}</span>
      </div>
      <loader-content :ref="(el: any) => favoriteGamesLoader = el">
      <div class="overflow-auto hidden-scrollbar header-content">
        <TransitionGroup name="animation-list" tag="div" class="d-flex flex-row position-relative">
          <game-icon @favorite-changed="onFavoriteChange" v-for="(game, index) in store.getters.favoriteGames" :key="game.id" class="slide" :game="game"></game-icon>
        </TransitionGroup>
      </div>
      </loader-content>
    </div>


    <div class="header">
      <svg-icon icon="menu/games"></svg-icon>
      <span class="text-capitalize-first">{{$t('games')}}</span>
    </div>
    <loader-content :ref="(el: any) => hotGamesLoader = el">
    <div class="header-content">
      <div class="games-wrapper">
        <game-icon @favorite-changed="onFavoriteChange" v-for="(game, index) in state.hotGames" :key="game.id" :game="game"></game-icon>
      </div>
    </div>
    </loader-content>

    <router-link :to="{name: 'games'}" class="btn btn-outline-secondary text-capitalize-first all-games-btn">{{$t('all_games')}}</router-link>

  </div>
</template>
<style lang="scss" scoped>
.all-games-btn {
  margin: 0 var(--margin-normal) var(--margin-xl);
}
</style>
<script lang="ts" setup>
import TournamentCard from "@/components/tournaments/TournamentCard.vue";
import TournamentDTO from "@/models/TournamentDTO";
import SvgIcon from "@/components/SvgIcon.vue";
import LiveWin from "@/components/wins/LiveWin.vue";
import LiveWinDTO from "@/models/LiveWinDTO";
import {onMounted, onUnmounted, ref} from "vue";
import {api} from "@/service/APIClient";
import {reactive} from "@vue/reactivity";
import GameDTO from "@/models/GameDTO";
import Welcome from "@/components/banners/Welcome.vue";
import GameIcon from "@/components/games/GameIcon.vue";
import BannerDTO from "@/models/BannerDTO";
import {useStore} from "vuex";
import LoaderContent from "@/components/LoaderContent.vue";

const state = reactive({
  banners: [] as BannerDTO[],
  hotGames: [] as GameDTO[],
  liveUpdateInterval: null as number|any
});

const liveWinsLoader = ref<InstanceType<typeof LoaderContent> | null>(null)
const liveTournamentsLoader = ref<InstanceType<typeof LoaderContent> | null>(null)
const hotGamesLoader = ref<InstanceType<typeof LoaderContent> | null>(null)
const favoriteGamesLoader = ref<InstanceType<typeof LoaderContent> | null>(null)

const store = useStore()

const onFavoriteChange = (game: GameDTO) => {
  if (game.isFavorite) {
    store.dispatch('addFavoriteGame', game);
  } else {
    store.dispatch('removeFavoriteGame', game);
  }

  const hotItem = state.hotGames.find(g => g.id === game.id);
  if (hotItem) {
    hotItem.isFavorite = game.isFavorite
  }
}

onMounted(async () => {
  liveWinsLoader.value?.load(async () => {
    await store.dispatch('setLiveWins', await api.call.live.wins())
  });

  liveTournamentsLoader.value?.load(async () => {
    await store.dispatch('setLiveTournaments', await api.call.live.tournaments())
  });

  favoriteGamesLoader.value?.load(async () => {
    await store.dispatch('setFavoriteGames', store.getters.isLoggedIn ? await api.call.games.favorites() : [],)
  });

  hotGamesLoader.value?.load(async () => {
    state.hotGames = await api.call.games.hot()
  });

  state.banners = await api.call.banners.placement('home')
  state.liveUpdateInterval = setInterval(async () => {
    api.call.live.wins().then((resp) => store.dispatch('setLiveWins', resp))
    api.call.live.tournaments().then((resp) => store.dispatch('setLiveTournaments', resp))
  }, 10000);
})

onUnmounted(() => {
  clearInterval(state.liveUpdateInterval);
});

</script>
